import script from "./DeferPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeferPayment.vue?vue&type=script&setup=true&lang=ts"

import "./DeferPayment.vue?vue&type=style&index=0&id=4c2d49d5&scoped=true&lang=css"
script.__scopeId = "data-v-4c2d49d5"

export default script